import { cva } from '@/styled-system/css';

export const upsellBannerBodyRecipe = cva({
  base: {
    'display': {
      lg: 'inline',
    },
    'marginBlockStart': {
      lgDown: 'UpsellBanner.Body.margin.heading-toMessage.vert',
    },
    'marginInlineStart': {
      lg: 'UpsellBanner.Body.margin.heading-toMessage.horz',
    },

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'UpsellBanner.Body.neutral.text',
      },
      soft: {
        color: 'UpsellBanner.Body.soft.text',
      },
      hero: {
        color: 'UpsellBanner.Body.hero.text',
      },
      impact: {
        color: 'UpsellBanner.Body.impact.text',
      },
    },
  },
});
